import React, { memo } from 'react'
import Link from 'next/link'

/**
 * Envuelve una tarjeta del listado en su enlace al detalle, salvo que esté
 * deshabilitada.
 *
 * Se usa para los autos vendidos (`status: ARCHIVED`). Cuando `disabled` es
 * `true` NO se renderiza el `<a>` en absoluto, en lugar de dejarlo y cancelar
 * el clic. La diferencia importa:
 *
 *  - Sin ancla no hay "abrir en pestaña nueva" ni arrastrar el enlace, que son
 *    caminos por los que el usuario llegaría igual a una ficha sin precio.
 *  - Los buscadores dejan de seguir una URL que, del otro lado, sólo redirige
 *    al listado.
 *
 * La API ya excluye los vendidos del listado, pero el SRP se genera de forma
 * estática: un auto vendido después de esa generación sigue apareciendo en la
 * página cacheada hasta que se regenera. Este componente cubre esa ventana.
 *
 * @param {boolean}   disabled Si el enlace debe omitirse.
 * @param {string}    href     Destino cuando sí está habilitado.
 * @param {ReactNode} children Contenido de la tarjeta.
 */
const CardLink = ({ disabled, href, children }) => {
  if (disabled) return children

  return (
    <Link
      href={href}
      passHref
    >
      {children}
    </Link>
  )
}

export default memo(CardLink)
